import { FacebookLoginAction } from './facebook-login';
import { HTTP_STATUS_OK, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';

const playerFoundMock: FacebookLoginAction = async (route: string) => {
	return Promise.resolve({
		status: HTTP_STATUS_OK,
		redirectUrl: `/?auth_result=player_found${route}`
	});
};

const playerNotFoundMock: FacebookLoginAction = async (route: string) => {
	return Promise.resolve({
		status: HTTP_STATUS_OK,
		redirectUrl: `/?auth_result=player_not_found${route}`
	});
};

const playerFoundDirectPlayMock: FacebookLoginAction = async (route: string) => {
	return Promise.resolve({
		status: HTTP_STATUS_OK,
		redirectUrl: `/?auth_result=player_found_direct_play${route}`
	});
};

const failMock: FacebookLoginAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_INTERNAL_SERVER_ERROR,
		errors: [{ code: 'be.api.auth.facebook.login-failed', message: 'Facebook login failed' }],
	});
};

export const facebookLoginMocks: {
	playerFoundMock: FacebookLoginAction;
	playerNotFoundMock: FacebookLoginAction;
	playerFoundDirectPlayMock: FacebookLoginAction;
	fail: FacebookLoginAction;
} = {
	playerFoundMock: playerFoundMock,
	playerNotFoundMock: playerNotFoundMock,
	playerFoundDirectPlayMock: playerFoundDirectPlayMock,
	fail: failMock,
};
